import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './Login.css';

import { useAlertDialog } from '../contexts/AlertDialogContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { openAlertDialog } = useAlertDialog();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
          "https://back-desalpe.onrender.com/api/auth/login",
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({ email, password }),
          }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to login');
      }

      // Assuming the backend returns a token
      if (data.token) {
        localStorage.setItem('authToken', data.token); // Store the token
        console.log('Admin login successful!');
        navigate('/admin'); // Redirect to admin page
      } else {
        throw new Error('No token received');
      }

    } catch (error) {
      console.error('Error during login:', error);
      openAlertDialog(error.message, 'Erreur de Connexion');
    }
  };

  return (
    <div className="login-container">
      <Link to="/" className="back-to-home-btn"><FaArrowLeft /> Retour à l'accueil</Link>
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Login</h2>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-submit-btn">Submit</button>
      </form>
    </div>
  );
};

export default Login;